import {
  Grid,
  IconButton,
  Link,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MailIcon from "@mui/icons-material/Mail";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";

import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import { motion } from "framer-motion";
import { baseurl } from "../../config";
import footerConstants from "../../data/footer.json";

type Props = {};

interface ILink {
  link: string;
  path: string;
}

const Footer = (props: Props) => {
  const theme = useTheme();
  const currentDate = new Date();
  const tab = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Stack
      direction="column"
      alignItems={"center"}
      justifyContent={"center"}
      spacing={4}
      p={2}
      bgcolor={"customColors.clr2"}
      sx={{
        marginTop: "0 !important",
      }}
    >
      <Grid container item justifyContent={"space-evenly"} xs={15} spacing={4}>
        {!tab && (
          <Grid
            item
            xs={12}
            md={2}
            m={1}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "2px !important",
            }}
            alignItems={"center"}
            justifyContent={"center"}
            component={Paper}
            elevation={2}
            bgcolor={"cutomColors.clr3"}
          >
            <motion.img
              src={`${baseurl}${footerConstants?.img_source}`}
              initial={{ scale: 0 }}
              whileInView={{
                scale: 1,
                transition: { duration: 0.5 },
              }}
              alt="logo"
              style={{
                height: "250px",
              }}
            />
          </Grid>
        )}
        <Grid
          item
          xs={12}
          md={3.5}
          m={1}
          component={Paper}
          elevation={2}
          sx={{
            padding: "2px !important",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
          bgcolor={"cutomColors.clr3"}
        >
          <Stack
            direction="column"
            m={1}
            alignItems={"flex-start"}
            justifyContent={"space-evenly"}
          >
            {footerConstants?.school_timings?.map((times, index) => (
              <>
                <Typography
                  textAlign="left"
                  variant="body1"
                  key={index}
                  sx={{
                    fontFamily: "inherit",
                    fontWeight: "600",
                    mt: 1,
                    fontSize: tab ? "0.8rem" : "1rem",
                  }}
                  component={motion.div}
                  initial={{ x: -50, opacity: 0 }}
                  whileInView={{
                    x: 0,
                    opacity: 1,
                    transition: { delay: (index + 1) * 0.1 },
                  }}
                >
                  {times?.headings}
                </Typography>
                {times?.time?.map((t, jindex) => (
                  <Typography
                    textAlign="justify"
                    variant="body2"
                    key={jindex}
                    sx={{
                      fontFamily: "inherit",
                      display: "block",
                      fontSize: tab ? "0.5rem" : "0.8rem",
                    }}
                    component={motion.div}
                    initial={{ x: -100, opacity: 0 }}
                    whileInView={{
                      x: 0,
                      opacity: 1,
                      transition: { delay: (jindex + index + 1) * 0.1 },
                    }}
                  >
                    {t}
                  </Typography>
                ))}
              </>
            ))}
          </Stack>
          {/* <Stack
            direction="row"
            spacing={2}
            ml={1}
            mb={1}
            alignItems={"center"}
            sx={{}}
          >
            <IconButton
              sx={{
                color: "white",
                backgroundColor: "customColors.clr2",
                ":hover": {
                  backgroundColor: "#4267B2",
                  color: "white",
                },
              }}
              component={motion.div}
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{
                opacity: 1,
                scale: 1,
                transition: {
                  duration: 0.1,
                  ease: [0, 0.71, 0.2, 1.01],
                  scale: {
                    type: "spring",
                    damping: 5,
                    stiffness: 100,
                    restDelta: 0.001,
                  },
                },
              }}
            >
              <FacebookOutlinedIcon />
            </IconButton>
            <IconButton
              sx={{
                color: "white",
                backgroundColor: "customColors.clr2",
                "&:hover": {
                  background:
                    "linear-gradient(to right, #f9ce34, #ee2a7b, #6228d7)",
                  color: "white",
                },
              }}
              component={motion.div}
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{
                opacity: 1,
                scale: 1,
                transition: {
                  duration: 0.1,
                  ease: [0, 0.71, 0.2, 1.01],
                  scale: {
                    type: "spring",
                    damping: 5,
                    stiffness: 100,
                    restDelta: 0.001,
                  },
                },
              }}
            >
              <InstagramIcon />
            </IconButton>
            <IconButton
              sx={{
                color: "white",
                backgroundColor: "customColors.clr2",
                ":hover": {
                  backgroundColor: "#FF0000",
                  color: "white",
                },
              }}
              component={motion.div}
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{
                opacity: 1,
                scale: 1,
                transition: {
                  duration: 0.1,
                  ease: [0, 0.71, 0.2, 1.01],
                  scale: {
                    type: "spring",
                    damping: 5,
                    stiffness: 100,
                    restDelta: 0.001,
                  },
                },
              }}
            >
              <YouTubeIcon />
            </IconButton>
          </Stack> */}
          <Stack direction="row" spacing={2} ml={1} mb={1} alignItems="center">

            {/* Facebook */}
            <motion.a
              href="https://www.facebook.com/share/1Uq9iDR47V/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "inline-block" }}
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{
                opacity: 1,
                scale: 1,
                transition: {
                  duration: 0.1,
                  ease: [0, 0.71, 0.2, 1.01],
                  scale: {
                    type: "spring",
                    damping: 5,
                    stiffness: 100,
                    restDelta: 0.001,
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  color: "white",
                  backgroundColor: "customColors.clr2",
                  "&:hover": {
                    backgroundColor: "#4267B2",
                    color: "white",
                  },
                }}
              >
                <FacebookOutlinedIcon />
              </IconButton>
            </motion.a>

            {/* Instagram */}
            <IconButton
              sx={{
                color: "white",
                backgroundColor: "customColors.clr2",
                "&:hover": {
                  background:
                    "linear-gradient(to right, #f9ce34, #ee2a7b, #6228d7)",
                  color: "white",
                },
              }}
              component={motion.div}
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
            >
              <InstagramIcon />
            </IconButton>

            {/* YouTube */}
            <motion.a
              href="https://www.youtube.com/watch?v=KDcilYS6iCs"
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "inline-block" }}
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{
                opacity: 1,
                scale: 1,
                transition: {
                  duration: 0.1,
                  ease: [0, 0.71, 0.2, 1.01],
                  scale: {
                    type: "spring",
                    damping: 5,
                    stiffness: 100,
                    restDelta: 0.001,
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  color: "white",
                  backgroundColor: "customColors.clr2",
                  "&:hover": {
                    backgroundColor: "#FF0000",
                    color: "white",
                  },
                }}
              >
                <YouTubeIcon />
              </IconButton>
            </motion.a>

          </Stack>
        </Grid>
        <Grid
          item
          xs={12}
          md={3.5}
          component={Paper}
          elevation={2}
          m={1}
          sx={{ padding: "2px !important" }}
          bgcolor={"cutomColors.clr3"}
        >
          <Stack
            m={1}
            direction="column"
            alignItems={"flex-start"}
            justifyContent={"space-evenly"}
          >
            {footerConstants?.other_timings?.map((times, index) => (
              <>
                <Typography
                  textAlign="justify"
                  variant="body1"
                  key={index}
                  sx={{
                    fontWeight: "600",
                    fontFamily: "inherit",
                    fontSize: tab ? "0.8rem" : "1rem",
                    mt: 1,
                  }}
                  component={motion.div}
                  initial={{ x: -50, opacity: 0 }}
                  whileInView={{
                    x: 0,
                    opacity: 1,
                    transition: { delay: (index + 1) * 0.1 },
                  }}
                >
                  {times?.headings}
                </Typography>
                {times?.time?.map((t, jindex) => (
                  <Typography
                    textAlign="justify"
                    variant="body2"
                    key={jindex}
                    sx={{
                      display: "block",
                      fontFamily: "inherit",
                      fontSize: tab ? "0.5rem" : "0.8rem",
                    }}
                    component={motion.div}
                    initial={{ x: -100, opacity: 0 }}
                    whileInView={{
                      x: 0,
                      opacity: 1,
                      transition: { delay: (jindex + index + 1) * 0.1 },
                    }}
                  >
                    {t}
                  </Typography>
                ))}
              </>
            ))}
          </Stack>
        </Grid>
        <Grid
          item
          xs={12}
          m={1}
          md={2}
          sx={{ padding: "4px !important" }}
          bgcolor={"cutomColors.clr3"}
        >
          <Typography
            textAlign="justify"
            variant="body1"
            sx={{ fontWeight: "600", fontFamily: "inherit", color: "white" }}
            mb={2}
            component={motion.div}
            initial={{ scale: 0 }}
            whileInView={{
              scale: 1,
              transition: { duration: 0.5, delay: 0.1 },
            }}
          >
            POLICIES
          </Typography>
          <Grid container columns={{ xs: 1 }} spacing={2}>
            {footerConstants?.policylinks?.map((value: ILink, i: number) => (
              <Grid
                item
                xs={1}
                key={i}
                component={motion.div}
                initial={{ scale: 0 }}
                whileInView={{
                  scale: 1,
                  transition: { duration: 0.5, delay: i * 0.1 },
                }}
              >
                <Link
                  href={value?.path}
                  sx={{
                    fontSize: "0.8rem",
                    display: "flex !important",
                    alignItems: "center !important",
                    color: "white",
                    ":hover": {
                      cursor: "pointer",
                    },
                  }}
                  underline="hover"
                >
                  <ArrowForwardIosIcon
                    sx={{
                      color: "text.secondary",
                      fontSize: "inherit",
                      minWidth: "fit-content",
                    }}
                  />
                  {value?.link}
                </Link>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
      <Stack
        direction={{ xs: "column", md: "row" }}
        p={2}
        fontSize={"0.8rem"}
        component={Paper}
        elevation={4}
        width={"97%"}
        bgcolor={"customColors.clr3"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={"center"}
          spacing={2}
        >
          <Stack
            flexDirection={"row"}
            alignItems={"center"}
            component={motion.div}
            initial={{ scale: 0 }}
            whileInView={{
              scale: 1,
              transition: { duration: 0.5, delay: 0.1 },
            }}
          >
            <MailIcon fontSize="small" />{" "}
            <span> stxavierspune37@gmail.com</span>
          </Stack>
          <Stack
            flexDirection={"row"}
            alignItems={"center"}
            component={motion.div}
            initial={{ scale: 0 }}
            whileInView={{
              scale: 1,
              transition: { duration: 0.5, delay: 0.2 },
            }}
          >
            <PhoneIcon fontSize="small" /> <span>+91 8149830102</span>
          </Stack>
          <Stack
            flexDirection={"row"}
            alignItems={"center"}
            component={motion.div}
            initial={{ scale: 0 }}
            whileInView={{
              scale: 1,
              transition: { duration: 0.5, delay: 0.3 },
            }}
          >
            <LocationOnIcon fontSize="small" /> <span>Pune</span>
          </Stack>
        </Stack>
        <Typography
          variant="body2"
          textAlign="center"
          sx={{
            display: "flex",
            fontFamily: "inherit",
            flexWrap: "nowrap",
            overflow: "auto",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.8rem",
          }}
          component={motion.div}
          initial={{ scale: 0 }}
          whileInView={{
            scale: 1,
            transition: { duration: 0.5, delay: 0.4 },
          }}
        >
          © {currentDate.getFullYear()} St. Xaviers School, Pune. All Rights
          Reserved.
        </Typography>
        <Typography
          variant="body2"
          textAlign="center"
          sx={{
            display: "flex",
            fontFamily: "inherit",
            flexWrap: "nowrap",
            overflow: "auto",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.8rem",
          }}
          component={motion.div}
          initial={{ scale: 0 }}
          whileInView={{
            scale: 1,
            transition: { duration: 0.5, delay: 0.5 },
          }}
        >
          Developed & Maintained By -&nbsp;
          <Link href="https://www.akronsystems.com/Home.aspx" target="_blank">
            Akron Systems
          </Link>
        </Typography>
      </Stack>
    </Stack>
  );
};

export default Footer;
